'use client';

import { useRouter } from 'next/navigation';
import { useState } from 'react';

import { Button, ButtonVariant, Column } from '@bytel/trilogy-react';

import { ProductChildFull } from '@app-types/product';
import { UserType } from '@app-types/user';

import { getCart } from '@helpers/cart';
import { paths } from '@helpers/path';

import { sendProductOtherPlansTracking } from '@product-detail/helpers';

export type TicketRenewalCTAProps = {
    currentProduct: ProductChildFull;
    user?: UserType;
    contractId?: string;
    renewalRedirectWall?: boolean;
};

export function TicketRenewalCTA({ currentProduct, contractId, user, renewalRedirectWall }: TicketRenewalCTAProps) {
    const [isLoadingOtherOffers, setIsLoadingOtherOffers] = useState<boolean>(false);
    const router = useRouter();

    const handleGetOtherOffer = async () => {
        if (renewalRedirectWall) {
            router.push(paths.phoneWall);
            return;
        }
        sendProductOtherPlansTracking(true, 'Voir les autres offres');
        setIsLoadingOtherOffers(true);
        const cart = await getCart(user, contractId);
        cart.addProductsToCart([currentProduct.gencode], false, true).then(() => {
            router.push(paths.renewalPlans);
            setIsLoadingOtherOffers(false);
        });
    };
    return (
        <Column>
            <Button
                variant={ButtonVariant.PRIMARY}
                onClick={handleGetOtherOffer}
                loading={isLoadingOtherOffers}
                fullwidth
                data-cy='other-offers-cta'
            >
                Voir les autres offres
            </Button>
        </Column>
    );
}
